type Props = {
  id: string;
  index: string;
  title: string;
  accent?: string;
  desc?: string;
};

export default function SectionTitle({ id, index, title, accent, desc }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <span className="num inline-flex h-6 w-8 items-center justify-center rounded-md bg-foreground-950 text-xs font-bold text-background-50">
          {index}
        </span>
        <span className="h-px w-8 bg-primary-400" />
        <span className="text-xs font-semibold tracking-widest text-primary-600">{accent}</span>
      </div>
      <div className="flex flex-col gap-1">
        <h4 className="text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
          <a href={`#${id}`} className="transition-colors hover:text-primary-600">
            {title}
          </a>
        </h4>
        {desc && <p className="text-sm text-foreground-700 md:text-[15px]">{desc}</p>}
      </div>
    </div>
  );
}